import AudioFactory from 'scripts/application/lib/audio_factory';

export default function() {
  AudioFactory.create = () => new Audio();
}



// WEBPACK FOOTER //
// ./src/scripts/configuration/configure_system_audio.js